export default {"src":"/_next/static/media/close.0f5b4c38.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};